/**
 * @typedef {import('../index').CellLayoutConfig} CellLayoutConfig
 */

/**
 * @param {CellLayoutConfig} a
 * @param {CellLayoutConfig}b
 * @returns {number}
 */
export const positionComparator = (a, b) => {
    const aPositionInfo = a.PositionInfo;
    const bPositionInfo = b.PositionInfo;
    if (aPositionInfo.Row !== bPositionInfo.Row) {
        return aPositionInfo.Row - bPositionInfo.Row;
    }
    return aPositionInfo.Column - bPositionInfo.Column;
};

/**
 * @param {CellLayoutConfig} a
 * @param {CellLayoutConfig}b
 * @returns {boolean}
 */
export const sameColumn = (a, b) => {
    const aPositionInfo = a.PositionInfo;
    const bPositionInfo = b.PositionInfo;

    return (
        (aPositionInfo.Column <= bPositionInfo.Column &&
            aPositionInfo.Column + aPositionInfo.Columns >
                bPositionInfo.Column) ||
        (bPositionInfo.Column <= aPositionInfo.Column &&
            bPositionInfo.Column + bPositionInfo.Columns >
                aPositionInfo.Column) ||
        (aPositionInfo.Column <= bPositionInfo.Column &&
            aPositionInfo.Column + aPositionInfo.Columns >=
                bPositionInfo.Column + bPositionInfo.Columns) ||
        (bPositionInfo.Column <= aPositionInfo.Column &&
            bPositionInfo.Column + bPositionInfo.Columns >=
                aPositionInfo.Column + aPositionInfo.Columns)
    );
};
